import type { FormatStrings } from "@skilitics/localization";

export type PlayerPalette = {
  main: string;
  light: string;
  dark: string;
  foreground: string;
};

// TODO: make this a zod type in a pure core theming package (no themes in it)
export const playerThemePaletteName = [
  "background",
  "signature",
  "signatureAccent",
  "content",
  "contentWell",
  "aside",
  "asideAccent",
  "asideHover",
  "actionButton",
  "progressiveButton",
  "regressiveButton",
  "destructiveButton",
  "neutralButton",
  "neutralActiveButton",
  "component",
  "componentAccent",
  "errorMessage",
] as const;

export type PlayerThemePaletteName = (typeof playerThemePaletteName)[number];

export type PlayerThemePaletteOrOverride = PlayerThemePaletteName | PlayerPalette;

export const paletteFormatStrings = {
  main: {
    en: "Main",
  },
  foreground: {
    en: "Foreground",
  },
  light: {
    en: "Light",
  },
  dark: {
    en: "Dark",
  },
} satisfies Record<keyof PlayerPalette, FormatStrings>;
